import * as THREE from 'three'
import anime from 'animejs'
import { Manual } from "types/data";
import { AnimationAction } from 'three/src/animation/AnimationAction';

interface initProps {
  animations:  THREE.AnimationClip[],
  truck: THREE.Scene,
  bindDom: any,
  onFinish: Function,
  models: {
    labels: any[],
    panel: any[],
    levers: any[],
  }
}

declare global {
  interface Window { 
    TweenMax: any,
    Draggable: any,
    TimelineMax: any,
    Linear: any
  }
}

const TweenMax = window.TweenMax
const Draggable = window.Draggable
const TimelineMax = window.TimelineMax
const Linear = window.Linear


export default class {
  props?: initProps
  drag: any
  tl?:  anime.AnimeInstance
  activeAction?: any
  actions?: {
    [x: string]: AnimationAction
  }
  mixer?: THREE.AnimationMixer

  init(props: initProps) {
    this.props = props

    this.mixer = new THREE.AnimationMixer(props.truck)
    
    this.actions = props.animations.reduce((acc, item) => ({...acc, [item.name]: this.mixer!.clipAction(item)}), {})
    
    this.props.models.labels.forEach((item: THREE.Mesh) => {
      //@ts-ignore
      const newMat = item.material.clone()
      item.material = newMat
    })
    this.props.models.levers.forEach((item: THREE.Mesh) => {
      //@ts-ignore
      const newMat = item.material.clone()
      item.material = newMat
    })

    this.initDrag()
  }
  
  initDrag() {
  }

  reset(reverse?: Boolean) {
    const path = anime.path(reverse ? '#leversPath' : '#leversPath2')
    TweenMax.set('.svgtarget', !reverse ? {x: 38, y: 181} : {x: 7, y: 7})
    
    if(this.activeAction) this.activeAction.paused = false
    this.mixer!.update(-this.mixer!.time)
    this.mixer!.update(0)

    this.tl = anime({
      targets: '.knob',
      translateX: path('x'),
      translateY: path('y'),
      rotate: path('angle'),
      easing: 'linear',
      duration: 1,
      loop: true
    })

    this.tl.reverse()
    this.tl.seek(0.999)
    this.tl.paused = true
    
    const self = this
    const D = document.createElement('div')

    if(this.drag) this.drag[0].kill()
    this.drag = Draggable.create(D, {
      trigger: '.knob',
      type: 'y',
      bounds:{ 
        minY: reverse ? -200 : 0,
        maxY: reverse ? 0 : 200
      },
      onDrag: function() {
        self.update(this, reverse)
      },
      onThrowUpdate: function() {
        self.update(this, reverse)
      } 
    }) 

  }

  update = ({y}: {y: number}, reverse?: Boolean) => {
    const progress = 1 - Math.abs(y/200)
    this.tl!.seek(progress)

    this.activeAction.paused = false
    const duration = this.activeAction._clip.duration
    const targetTime = duration * (false ?
      (progress === 1 ? 0.99999 : progress)
      :
      (1 - progress)
    )

    this.mixer!.update(-this.mixer!.time)
    this.mixer!.update(targetTime)
    if(progress === (0)) {
      this.props!.onFinish()
    }
  }

  initSim = (data: Manual) => {
    const { models, bindDom } = this.props!
    const targetModel = models.levers.find(item => item.name === data.lever)!

    if(targetModel) {
      bindDom(targetModel)
      
      this.activeAction = this.actions![data.clipName]
      
      this.mixer!.update(-this.mixer!.time)
      Object.keys(this.actions!).forEach(item => {
        this.actions![item].paused = true
        this.activeAction.clampWhenFinished = false
      })
      
      this.activeAction.clampWhenFinished = true
      this.activeAction.loop = THREE.LoopOnce
    
    
      this.activeAction.play()
        
      
      models.labels.forEach((item: THREE.Mesh) => {
        if(item.name !== data.label) {
          //@ts-ignore
          item.material.opacity = 0.4
          //@ts-ignore
          item.material.transparent = true
          
          // item.material.color.set(0x000000)
        } else {
          //@ts-ignore
          item.material.opacity = 1
        }
      })
    }
    
    models.levers.forEach((item: THREE.Mesh) => {
      if(item.name !== data.lever) {
        //@ts-ignore
        item.material.color.set(0x333333)
        //@ts-ignore
        // item.material.opacity = 0.8
        //@ts-ignore
        item.material.emissive.set(0x000000)
        // item.material.transparent = true 
      } else {
        //@ts-ignore
        item.material.color.set(0xffffff)
        //@ts-ignore
        item.material.opacity = 1
        //@ts-ignore
        item.material.emissive.set(0x222222)
        // item.material.transparent = false 
        // item.material.color.set()
      }
    })

    //@ts-ignore
    models.panel[0].material.color.set(0x000000)
    // models.panel[0].materal.color.set(0x000000)
  }
}